module.exports = __webpack_public_path__ + "static/media/Quartz.78efa2ec.jpg";